import React from 'react';
import FiduciaLogo from '../../../../../../../../../assets/images/fiducia-logo.jpg';
import {
  celMaskPhone,
  cpfCnpjMask,
} from '../../../../../../../../../utils/masks';

function PdfGlobal(props: any) {
  const { ctx } = props;
  return (
    <div style={{ width: '740px', margin: 'auto' }}>
      <div
        className="WordSection4"
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <p style={{ padding: '0 0 0 25pt' }}>
          <span style={{ lineHeight: '26pt' }}>FICHA CADASTRAL</span>
          <br />
          <b style={{ fontSize: '20pt', lineHeight: '26pt' }}>
            PESSOA FÍSICA -
          </b>
          <br />
          <b style={{ fontSize: '20pt', lineHeight: '26pt' }}>
            ABERTURA DE CONTA
          </b>
        </p>
        <img
          src={FiduciaLogo}
          alt="Fidúcia Logo"
          height={82}
          width={300}
          style={{ objectFit: 'contain', objectPosition: 'center' }}
        />
      </div>
      <span style={{ fontSize: '12.0pt', fontFamily: '"Cambria",serif' }}>
        <br style={{ pageBreakBefore: 'auto' }} />
      </span>
      <div className="WordSection6">
        <table
          style={{
            marginLeft: '22pt',
            borderCollapse: 'collapse',
            border: 'none',
            width: '740px',
          }}
          width={740}
          cellSpacing={0}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: '8.0pt' }}>
              <td
                rowSpan={2}
                style={{
                  background: '#FBFBFB',
                  border: 'solid windowtext 1.0pt',
                }}>
                <p
                  style={{
                    marginLeft: '1.7pt',
                    textAlign: 'center',
                    lineHeight: '19.0pt',
                  }}>
                  <b>
                    <span style={{ color: 'black' }}>
                      Uso exclusivo <br />
                      Fiducia SCMEPP
                    </span>
                  </b>
                </p>
              </td>
              <td
                style={{
                  border: 'solid windowtext 1.0pt',
                  borderLeft: 'none',
                  background: '#FBFBFB',
                  padding: '5px',
                  height: '8.0pt',
                }}>
                <p style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: '8.0pt', color: 'black' }}>
                    Processo
                  </span>
                </p>
              </td>
              <td
                style={{
                  border: 'solid windowtext 1.0pt',
                  borderLeft: 'none',
                  background: '#FBFBFB',
                  padding: '5px',
                  height: '8.0pt',
                }}>
                <p style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: '8.0pt', color: 'black' }}>
                    Tipo de cliente
                  </span>
                </p>
              </td>
              <td
                style={{
                  border: 'solid windowtext 1.0pt',
                  borderLeft: 'none',
                  background: '#FBFBFB',
                  padding: '0in 5.4pt 0in 5.4pt',
                  height: '8.0pt',
                }}>
                <p style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: '8.0pt', color: 'black' }}>
                    Código do Cliente
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '29.25pt' }}>
              <td
                style={{
                  width: '148.65pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: '#FBFBFB',
                  padding: '0in 5.4pt 0in 5.4pt',
                  height: '29.25pt',
                }}
                width={198}>
                <p
                  style={{
                    fontSize: '7.5pt',
                    color: 'black',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}>
                  <span
                    style={{
                      display: 'block',
                      height: 10,
                      width: 10,
                      border: '1px solid #000',
                      marginRight: '5pt',
                      marginLeft: '5pt',
                    }}
                  />{' '}
                  Abertura
                  <span
                    style={{
                      display: 'block',
                      height: 10,
                      width: 10,
                      marginLeft: '5pt',
                      border: '1px solid #000',
                      marginRight: '5pt',
                    }}
                  />{' '}
                  Atualização
                </p>
              </td>
              <td
                style={{
                  width: '160pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: '#FBFBFB',
                  padding: '0in 5.4pt 0in 5.4pt',
                  height: '29.25pt',
                }}
                width={133}
                valign="top">
                <p
                  style={{
                    fontSize: '7.5pt',
                    color: 'black',
                    display: 'flex',
                    alignContent: 'center',
                    alignItems: 'center',
                    height: 38,
                  }}>
                  <span
                    style={{
                      display: 'block',
                      height: 10,
                      width: 10,
                      border: '1px solid #000',
                      marginRight: '5pt',
                      marginLeft: '5pt',
                    }}
                  />{' '}
                  Contratante
                  <span
                    style={{
                      display: 'block',
                      height: 10,
                      width: 10,
                      marginLeft: '5pt',
                      border: '1px solid #000',
                      marginRight: '5pt',
                    }}
                  />{' '}
                  Agente Fiduciário
                </p>
              </td>
              <td
                style={{
                  width: '90.9pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: '#FBFBFB',
                  padding: '0in 5.4pt 0in 5.4pt',
                  height: '29.25pt',
                }}
                width={133}
                valign="top">
                <p style={{ lineHeight: '19.0pt' }}>&nbsp;</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="WordSection8">
        <p style={{ lineHeight: '19.0pt' }}>&nbsp;</p>
        <p style={{ marginLeft: '26.4pt' }}>
          <b style={{ fontSize: '8.5pt' }}>DADOS PESSOAIS</b>
        </p>
      </div>
      <div className="WordSection9">
        <table
          className="MsoNormalTable"
          style={{
            marginLeft: '24.9pt',
            borderCollapse: 'collapse',
            width: '740px',
          }}
          width={740}
          cellSpacing={0}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: '26.25pt' }}>
              <td
                colSpan={5}
                style={{
                  width: '399.85pt',
                  border: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '26.25pt',
                }}
                width={533}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      lineHeight: '104%',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Denominação / Razão Social:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                      letterSpacing: '.1pt',
                    }}>
                    {ctx.companyName}
                  </b>
                </p>
              </td>
              <td
                style={{
                  width: '146.9pt',
                  border: 'solid black 1.0pt',
                  borderLeft: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.25pt',
                }}
                width={196}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                      letterSpacing: '-.4pt',
                    }}>
                    CPF:
                  </span>
                  <br />
                  <span
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {cpfCnpjMask(ctx.cpfCnpj)}
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '26.75pt' }}>
              <td
                colSpan={3}
                style={{
                  width: '273pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.75pt',
                }}
                width={273}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Nome do Pai:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={3}
                style={{
                  width: '273.75pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.75pt',
                }}
                width="273.75"
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Nome da mãe:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: '25.6pt' }}>
              <td
                colSpan={2}
                style={{
                  width: '121.25pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={162}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Data de Nascimento:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.birthday}
                  </span>
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  width: '214.85pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={286}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Nacionalidade:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  width: '210.65pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={281}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Naturalidade: (Municipio)
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.city}
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '25.6pt' }}>
              <td
                colSpan={2}
                style={{
                  width: '121.25pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={162}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Sexo
                  </span>
                  <br />
                  <i
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      paddingTop: 2,
                      display: 'flex',
                      margin: 0,
                      fontStyle: 'normal',
                    }}>
                    <span
                      style={{
                        display: 'block',
                        height: 10,
                        width: 10,
                        border: '1px solid #000',
                        marginRight: '4pt',
                      }}
                    />{' '}
                    Masculino
                    <span
                      style={{
                        display: 'block',
                        height: 10,
                        width: 10,
                        marginLeft: '5pt',
                        border: '1px solid #000',
                        marginRight: '4pt',
                      }}
                    />{' '}
                    Feminino
                  </i>
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  width: '214.85pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={286}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Estado Civil:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  width: '210.65pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={281}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Nome do cônjuge ou companheiro(a):
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: '29.05pt' }}>
              <td
                colSpan={2}
                style={{
                  width: '121.25pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={162}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Tipo de Documento: (RG, CNH, entidade de classe):
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Nº de registro:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Orgão emissor:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>UF:</span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Data de emissão:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: '29.05pt' }}>
              <td
                colSpan={2}
                style={{
                  width: '121.25pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={162}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Telefone (DDD+Nº):
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {celMaskPhone(ctx.phone)}
                  </span>
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  width: '214.85pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={286}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Celular
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.cel
                      .replace(/(\d{2})(\d)/, '($1) $2')
                      .replace(/(\d)(\d{4})$/, '$1-$2')}
                  </span>
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    E-mail para credenciais de contas e comunicação via Internet
                    Banking:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.email}
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '29.05pt' }}>
              <td
                colSpan={4}
                style={{
                  width: '121.25pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={162}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Logradouro (rua, avenida):
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.publicPlace}
                  </span>
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Número:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.number}
                  </span>
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Complemento:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.complement}
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '29.05pt' }}>
              <td
                colSpan={2}
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Bairro:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.district}
                  </span>
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Cidade:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.city}
                  </span>
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>UF:</span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.country}
                  </span>
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    CEP:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }}>
                    {ctx.cep}
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p style={{ lineHeight: '30px' }}>&nbsp;</p>
      <div className="WordSection11">
        <p
          style={{
            marginLeft: '25pt',
            fontSize: '7pt',
            color: 'black',
            letterSpacing: '-.1pt',
          }}>
          <b>DADOS PROFISSIONAIS</b>
        </p>
      </div>
      <div className="WordSection12">
        <table
          className="MsoNormalTable"
          style={{
            marginLeft: '24.9pt',
            borderCollapse: 'collapse',
            borderTop: 'solid black 1.0pt',
            width: '740px',
          }}
          width={740}
          cellSpacing={0}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: '26.75pt' }}>
              <td
                colSpan={3}
                style={{
                  width: '273pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.75pt',
                }}
                width={273}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Empresa:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={3}
                style={{
                  width: '273.75pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.75pt',
                }}
                width="273.75"
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Cargo Ocupado:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: '26.75pt' }}>
              <td
                colSpan={6}
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.75pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Remuneração:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: '26.75pt' }}>
              <td
                colSpan={6}
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.75pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Tempo de serviço:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: '26.75pt' }}>
              <td
                colSpan={6}
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.75pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Logradouro: (rua, avenida)
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: '29.05pt' }}>
              <td
                colSpan={4}
                style={{
                  width: '121.25pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={162}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Logradouro (rua, avenida):
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Número:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Complemento:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: '29.05pt' }}>
              <td
                colSpan={2}
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Bairro:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    Cidade:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>UF:</span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                colSpan={1}
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span style={{ fontSize: '7.5pt', color: 'black' }}>
                    CEP:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p style={{ lineHeight: '30px' }}>&nbsp;</p>
      <div className="WordSection11">
        <p
          style={{
            marginLeft: '25pt',
            fontSize: '7pt',
            lineHeight: '102%',
            color: 'black',
            letterSpacing: '-.1pt',
          }}>
          <b>OUTRAS RENDAS</b>
        </p>
      </div>
      <div className="WordSection14">
        <table
          className="MsoNormalTable"
          style={{
            marginLeft: '25pt',
            borderCollapse: 'collapse',
            width: '740px',
          }}
          width={740}
          cellSpacing={0}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: 40 }}>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={350}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Descrição:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={350}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Valor:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: 40 }}>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={350}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Descrição:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={350}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Valor:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: 40 }}>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={350}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Descrição:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={350}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Valor:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: 40 }}>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={350}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Descrição:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={350}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Valor:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
            <tr style={{ height: 40 }}>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={350}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Descrição:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={350}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Valor:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p style={{ lineHeight: '30px' }}>&nbsp;</p>
      </div>
      <div className="WordSection11">
        <p style={{ fontSize: '7pt', paddingLeft: '25pt' }}>
          <b
            style={{
              marginLeft: '5pt',
              fontSize: '8.5pt',
              lineHeight: '102%',
              color: 'black',
              letterSpacing: '-.1pt',
            }}>
            DADOS DE IDENTIFICAÇÃO DO REPRESENTANTE/PROCURADOR
          </b>
          <br />
          (SE HOUVER)
        </p>
      </div>
      <table
        className="MsoNormalTable"
        style={{
          marginLeft: '25pt',
          borderCollapse: 'collapse',
          width: '740px',
        }}
        width={740}
        cellSpacing={0}
        cellPadding={0}>
        <tbody>
          <tr style={{ height: 40 }}>
            <td
              style={{
                border: 'solid black 1.0pt',
                padding: 5,
                height: '.25in',
              }}
              width={250}
              valign="top">
              <p
                style={{
                  marginRight: '0in',
                  marginBottom: '0in',
                  marginLeft: '3.25pt',
                }}>
                <span style={{ fontSize: '8pt', color: 'black' }}>
                  Nome completo:
                </span>
                <br />
                <span style={{ fontSize: '10pt', color: 'black' }} />
              </p>
            </td>
            <td
              style={{
                border: 'solid black 1.0pt',
                padding: 5,
                height: '.25in',
              }}
              width={250}
              valign="top">
              <p
                style={{
                  marginRight: '0in',
                  marginBottom: '0in',
                  marginLeft: '3.25pt',
                }}>
                <span style={{ fontSize: '8pt', color: 'black' }}>
                  Nº do documento de identificação:
                </span>
                <br />
                <span style={{ fontSize: '10pt', color: 'black' }} />
              </p>
            </td>
            <td
              style={{
                border: 'solid black 1.0pt',
                padding: 5,
                height: '.25in',
              }}
              width={200}
              valign="top">
              <p
                style={{
                  marginRight: '0in',
                  marginBottom: '0in',
                  marginLeft: '3.25pt',
                }}>
                <span style={{ fontSize: '8pt', color: 'black' }}>CPF:</span>
                <br />
                <span style={{ fontSize: '10pt', color: 'black' }} />
              </p>
            </td>
          </tr>
          <tr style={{ height: 40 }}>
            <td
              colSpan={6}
              style={{
                border: 'solid black 1.0pt',
                padding: 5,
                height: '.25in',
              }}
              width={740}
              valign="top">
              <p
                style={{
                  marginRight: '0in',
                  marginBottom: '0in',
                  marginLeft: '3.25pt',
                }}>
                <span style={{ fontSize: '8pt', color: 'black' }}>E-mail:</span>
                <br />
                <span style={{ fontSize: '10pt', color: 'black' }} />
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style={{ lineHeight: '70px' }}>&nbsp;</p>
      <div className="WordSection11">
        <p style={{ fontSize: '7pt', paddingLeft: '25pt' }}>
          <b
            style={{
              paddingLeft: '3pt',
              fontSize: '8.5pt',
              lineHeight: '102%',
              color: 'black',
              letterSpacing: '-.1pt',
            }}>
            DADOS DE IDENTIFICAÇÃO DO AGENTE FIDUCIÁRIO
          </b>
          <br />
          (SE HOUVER)
        </p>
      </div>
      <table
        className="MsoNormalTable"
        style={{
          marginLeft: '25pt',
          borderCollapse: 'collapse',
          width: '740px',
        }}
        width={740}
        cellSpacing={0}
        cellPadding={0}>
        <tbody>
          <tr style={{ height: 40 }}>
            <td
              style={{
                border: 'solid black 1.0pt',
                padding: 5,
                height: '.25in',
              }}
              width={250}
              valign="top">
              <p
                style={{
                  marginRight: '0in',
                  marginBottom: '0in',
                  marginLeft: '3.25pt',
                }}>
                <span style={{ fontSize: '8pt', color: 'black' }}>
                  Nome completo:
                </span>
                <br />
                <span style={{ fontSize: '10pt', color: 'black' }} />
              </p>
            </td>
            <td
              style={{
                border: 'solid black 1.0pt',
                padding: 5,
                height: '.25in',
              }}
              width={250}
              valign="top">
              <p
                style={{
                  marginRight: '0in',
                  marginBottom: '0in',
                  marginLeft: '3.25pt',
                }}>
                <span style={{ fontSize: '8pt', color: 'black' }}>
                  Nº do documento de identificação:
                </span>
                <br />
                <span style={{ fontSize: '10pt', color: 'black' }} />
              </p>
            </td>
            <td
              style={{
                border: 'solid black 1.0pt',
                padding: 5,
                height: '.25in',
              }}
              width={200}
              valign="top">
              <p
                style={{
                  marginRight: '0in',
                  marginBottom: '0in',
                  marginLeft: '3.25pt',
                }}>
                <span style={{ fontSize: '8pt', color: 'black' }}>CPF:</span>
                <br />
                <span style={{ fontSize: '10pt', color: 'black' }} />
              </p>
            </td>
          </tr>
          <tr style={{ height: 40 }}>
            <td
              colSpan={6}
              style={{
                border: 'solid black 1.0pt',
                padding: 5,
                height: '.25in',
              }}
              width={740}
              valign="top">
              <p
                style={{
                  marginRight: '0in',
                  marginBottom: '0in',
                  marginLeft: '3.25pt',
                }}>
                <span style={{ fontSize: '8pt', color: 'black' }}>E-mail:</span>
                <br />
                <span style={{ fontSize: '10pt', color: 'black' }} />
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style={{ lineHeight: '30px' }}>&nbsp;</p>
      <div className="WordSection20">
        <div className="WordSection11">
          <p style={{ fontSize: '7pt', paddingLeft: '25pt' }}>
            <b
              style={{
                paddingLeft: '3pt',
                fontSize: '8.5pt',
                lineHeight: '102%',
                color: 'black',
                letterSpacing: '-.1pt',
              }}>
              DECLARAÇÃO DO CLIENTE
            </b>
          </p>
        </div>
        <table
          className="MsoTableGrid"
          style={{
            marginLeft: '25pt',
            borderCollapse: 'collapse',
            border: 'none',
            width: '740px',
          }}
          width={740}
          cellSpacing={0}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: '159.15pt' }}>
              <td
                style={{
                  width: '740pt',
                  border: 'solid windowtext 1.0pt',
                  padding: '10pt',
                  height: '159.15pt',
                }}
                width={740}
                valign="top">
                <p style={{ lineHeight: '14pt', fontSize: '9pt' }}>
                  Autorizo a pesquisa dos créditos registrados para o CNPJ
                  informado no SCR – consoante ao previsto na Resolução 4.571,
                  do BANCO CENTRAL DO BRASIL – e em demais bureaus de crédito.
                </p>
                <p style={{ lineHeight: '14pt', fontSize: '9pt' }}>
                  Autorizo o compartilhamento dos dados do CNPJ informado com
                  todos os partícipes na operação, que ora contrato com a
                  FIDÚCIA SCMEPP.
                </p>
                <p style={{ lineHeight: '14pt', fontSize: '9pt' }}>
                  Declaro serem verdadeiras as informações prestadas e
                  autênticos os documentos apresentados, responsabilizando-me na
                  forma da lei (Artigo 299 do Código Penal). Estou ciente de que
                  os dados cadastrais por mim fornecidos servirão de base para a
                  confecção de meu cadastro e desde já, autorizo a fazer o uso
                  de todas as informações nele contidas para eventual cobrança,
                  através de terceiros pela Fidúcia contratados.
                </p>
                <p style={{ lineHeight: '14pt', fontSize: '9pt' }}>
                  Asseguro que os recursos decorrentes do empréstimo ou
                  financiamento por mim tomado não será destinado a finalidades
                  que possam causar danos socioambientais e/ou projetos em
                  desacordo com as Políticas Nacionais Socioambientais previstas
                  em Lei e normativos do BANCO CENTRAL DO BRASIL, que não
                  utilizarei, de forma direta ou indireta, os recursos
                  disponibilizados para a prática de ato que atente contra o
                  patrimônio público nacional ou estrangeiro, contra princípios
                  da administração pública ou contra os compromissos
                  internacionais assumidos pelo Brasil. Que não destinarei esse
                  recurso para o financiamento de práticas ilícitas, mas sim,
                  que em sua totalidade, esse crédito por mim tomado será
                  utilizado de forma produtiva, buscando retornos tangíveis e
                  intangíveis.
                </p>
                <p style={{ lineHeight: '14pt', fontSize: '9pt' }}>
                  Declaração de Ciência do CET: Declaro receber nessa
                  oportunidade todas as informações acerca do Custo Efetivo
                  Total-CET, porcentagem anual a ser paga na contratação de uma
                  operação de crédito e engloba todos os encargos e despesas
                  incidentes nas operações de crédito, juros remuneratórios,
                  tarifas, seguro, IOF e registro.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p style={{ lineHeight: '4.15pt' }}>&nbsp;</p>
        <table
          className="MsoNormalTable"
          style={{
            marginLeft: '25pt',
            borderCollapse: 'collapse',
            width: '740px',
          }}
          width={740}
          cellSpacing={0}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: '60pt' }}>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={200}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <b style={{ fontSize: '8.5pt', color: 'black' }}>
                    local e Data:
                  </b>
                </p>
              </td>
              <td
                style={{
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '.25in',
                }}
                width={500}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <b style={{ fontSize: '8.5pt', color: 'black' }}>
                    Assinatura do Proponente
                  </b>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="WordSection11">
        <p style={{ lineHeight: '5.15pt' }}>&nbsp;</p>
        <p style={{ fontSize: '7pt', paddingLeft: '25pt' }}>
          <b
            style={{
              paddingLeft: '3pt',
              fontSize: '8.5pt',
              lineHeight: '102%',
              padding: '5px',
              color: 'black',
              letterSpacing: '-.1pt',
            }}>
            DECLARAÇÃO DO RESPONSÁVEL PELO CADASTRAMENTO
          </b>{' '}
          (USO EXCLUSIVO DA FIDÚCIA SCMEPP)
        </p>
      </div>
      <div className="WordSection24">
        <table
          className="MsoNormalTable"
          cellSpacing={0}
          style={{
            marginLeft: '25pt',
            borderCollapse: 'collapse',
            width: '740px',
          }}
          width={740}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: '40pt' }}>
              <td
                colSpan={2}
                style={{
                  width: '546.85pt',
                  border: 'solid black 1.0pt',
                  padding: 5,
                  height: '31.5pt',
                }}
                width={729}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span
                    style={{
                      fontSize: '8.5pt',
                      color: 'black',
                      lineHeight: '10pt',
                    }}>
                    Responsabilizo-me pela conferência e exatidão das
                    informações constantes na ficha, bem como pelos elementos de
                    identificação e das demais informações apresentadas.{' '}
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '34.15pt' }}>
              <td
                style={{
                  width: '272.6pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: 5,
                  height: '34.15pt',
                }}
                width={363}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Local e data:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
              <td
                style={{
                  width: '274.25pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: 5,
                  height: '34.15pt',
                }}
                width={366}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                  }}>
                  <span style={{ fontSize: '8pt', color: 'black' }}>
                    Departamento de Normas FIDÚCIA SCMEPP:
                  </span>
                  <br />
                  <span style={{ fontSize: '10pt', color: 'black' }} />
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PdfGlobal;
